"use strict";
/*
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: IBM Cognos Analytics
 *
 * (C) Copyright IBM Corp. 2021, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importStar(require("react"));
const carbon_components_react_1 = require("carbon-components-react");
const react_dom_1 = require("react-dom");
const StringResource_1 = require("../nls/StringResource");
const utils_1 = require("../utils");
const COMPONENT_NAME = 'Search';
const DISPLAY_NAME = (0, utils_1.getDisplayName)(COMPONENT_NAME);
const DEFAULT_TID = (0, utils_1.getDefaultTid)(COMPONENT_NAME);
const CLEAR_BUTTON_TITLE = StringResource_1.stringResource.get('searchClearButtonTitle');
class ForwardRefSearch extends react_1.Component {
    constructor() {
        super(...arguments);
        // Work around for https://github.com/carbon-design-system/carbon/pull/11474
        // https://jsw.ibm.com/browse/BAUICOMMON-827
        this.addTitleAttr = () => {
            const node = (0, react_dom_1.findDOMNode)(this);
            const clearButtonElement = node.parentElement.getElementsByTagName('button');
            if (clearButtonElement) {
                clearButtonElement[0].setAttribute('title', CLEAR_BUTTON_TITLE);
            }
        };
    }
    componentDidMount() {
        this.addTitleAttr();
    }
    render() {
        const _a = this.props, { 
        // remove - remapped and local props
        'data-tid': dataTid } = _a, 
        // pass all other props to Carbon
        otherCarbonProps = tslib_1.__rest(_a, ['data-tid']);
        const mappedProps = {
            'data-tid': dataTid !== null && dataTid !== void 0 ? dataTid : DEFAULT_TID,
        };
        return react_1.default.createElement(carbon_components_react_1.Search, Object.assign({}, otherCarbonProps, mappedProps));
    }
}
ForwardRefSearch.propTypes = {
    'data-tid': prop_types_1.default.string,
};
const Search = react_1.default.forwardRef((props, ref) => {
    const otherProps = ref ? { innerRef: ref } : {};
    return react_1.default.createElement(ForwardRefSearch, Object.assign({}, props, otherProps));
});
Search.displayName = DISPLAY_NAME;
exports.default = Search;
